import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ReplaySubject, Subscription, concat, forkJoin } from 'rxjs';
import { catchError, debounceTime, last, map, switchMap, tap } from 'rxjs/operators';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { ChatService } from 'src/app/shared/services/rest/chat.service';
import { TaskService } from 'src/app/shared/services/rest/task.service';
import { SnackBarItem } from '../../../snack-bar/snack-bar-item';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { LoadingService } from 'src/app/shared/services/rest/loading.service';
import { casesModel } from 'src/app/shared/functions/casesModel';
import { OperationChatComponent } from 'src/app/components/atTasksDialog/operation-chat/operation-chat.component';

@Component({
  selector: 'app-forward-msgs',
  templateUrl: './forward-msgs.component.html',
  styleUrls: ['./forward-msgs.component.scss']
})
export class ForwardMsgsComponent extends BaseClass implements OnInit, OnDestroy {
  public filter: FormGroup;
  public isFormChange: boolean = false;
  public isSubmit: boolean = false;
  public isLoad: boolean = false;

  public tab: number = 2;
  public page: number = 1;
  public pagination: any;
  public task_id: any;
  public task_operation_id: any;

  public cardJobsPage: number = 1;
  public cardJobsPagination: any;

  throttle = 100;
  scrollUpDistance = 3.5;

  public chatsPage: number = 1;
  public chatsPagination: any;

  public chatsSub: Subscription;

  // public jobControl: FormControl = new FormControl('');
  // public jobs$: ReplaySubject<any> = new ReplaySubject<any>(1);
  public chats: any[] = [];

  public newChatName: FormControl = new FormControl('Forwarded Chat');
  public searchControl: FormControl = new FormControl('');
  public cardJobControl: FormControl = new FormControl('');
  public cardJobs$: ReplaySubject<any> = new ReplaySubject<any>(1);
  public cardJobs: any[] = [];

  public newJobControl: FormControl = new FormControl();
  public newJobs$: ReplaySubject<any> = new ReplaySubject<any>(1);
  public newJobs: any[] = [];
  public newJobsPage: number = 1;
  public newJobsPagination: any;
  public selectedChat: any;
  
  public isOpenAfter: boolean = false;

  public searchKey = 'q'

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ForwardMsgsComponent>,
    private fb: FormBuilder,
    private ls: LoadingService,
    private sm: StorageManagerService,
    private dialog: MatDialog,
    private chatService: ChatService,
    private taskService: TaskService,
    private layoutService: LayoutService
  ) { super() }

  ngOnInit(): void {
    console.log("ForwardMsgsComponent", this.data)
    this.dialogRef.addPanelClass("adding_executors_dialog")

    this.task_id = this.data.task ? this.data.task.id : this.data.chat.task_id;
    this.task_operation_id = this.data.work ? this.data.work.id : this.data.chat.task_operation_id;

    this.filter = this.fb.group({
      company_id: this.data.company.id,
      task_id: 0,
      task_operation_id: 0,
    })

    this.attachSubscriptions(
      this.cardJobControl.valueChanges.pipe(debounceTime(300)).subscribe((resp) => this.onCardJobsSearch(resp))
    )

    this.attachSubscriptions(
      this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe((resp) => {
        this.chatsPage = 1;
        this.selectedChat = undefined;
        this.getChats(this.chatsPage, resp)
      })
    )

    this.attachSubscriptions(
      this.dialogRef.backdropClick().subscribe(e => {
        e.preventDefault();
        if (this.isFormChange) {
          this.layoutService.openBottomSheet(this.dialogRef);
        } else {
          this.close();
        }
      })
    )

    
    this.getCardWorks(this.cardJobsPage);
    this.setCardAndJobID(this.task_id, this.task_operation_id)
    // this.chatsPage = 1;
    // this.getChats(this.chatsPage)
  }

  onFilterChats() {
    this.chatsPage = 1;
    this.selectedChat = undefined;
    this.getChats(this.chatsPage)
  }

  selectChat(item) {
    this.selectedChat = item;
  }

  setCardAndJobID(cardID, jobID) {
    this.filter.patchValue({
      task_id: cardID,
      task_operation_id: jobID,
    })

    this.chatsPage = 1;
    this.selectedChat = undefined;
    this.getChats(this.chatsPage)
  }

  selectJob(job) {
    this.filter.patchValue({
      task_operation_id: job.id,
    })
  }

  onCardJobsSearch(resp) {
    if (!this.cardJobs) {
      return;
    }

    if (!resp) {
      this.cardJobs$.next(this.cardJobs.slice());
      return;
    } else {
      resp = resp.toLowerCase();
    }
    // filter the banks
    this.cardJobs$.next(
      this.cardJobs.filter(z => (!!z.operation && z.operation.name.toLowerCase().indexOf(resp) > -1) || z.id.toString().indexOf(resp) > -1 || (z.name && z.name.toLowerCase().indexOf(resp) > -1) || (z.comment && z.comment.toLowerCase().indexOf(resp) > -1))
    );
  }

  getCardJobById(id) {
    return this.cardJobs.find(x => x.id == id);
  }

  getPrimaryTag(job) {
    if (job.parameterValuesToTask && job.parameterValuesToTask.length) {
      return job.parameterValuesToTask.find(x => !!x.is_primary)
    } else {
      return undefined
    }
  }

  getCardWorks(page) {
    this.attachSubscriptions(
      this.taskService.getWorks(page, this.data.company.id, {task_id: this.task_id}, '200').pipe(
        tap(el => {
          this.cardJobsPagination = {
            'pageCount': el.headers.get('x-pagination-page-count'),
            'perPage': el.headers.get('x-pagination-per-page'),
            'totalCount': el.headers.get('x-pagination-total-count'),
            'currentPage': el.headers.get('x-pagination-current-page'),
          }
        })
      ).subscribe(resp => {
        this.cardJobs.push(...resp.body.slice())
        this.cardJobs$.next(this.cardJobs.slice())
        this.cardJobsPage = this.cardJobsPage + 1;

        console.log(this.cardJobsPagination, this.cardJobs);
        if (+this.cardJobsPagination['currentPage'] != +this.cardJobsPagination['pageCount']) {
          this.getCardWorks(this.cardJobsPage);
        }
      })
    )
  }

  onDownChats($event) {
    if (this.chatsPagination['pageCount'] >= this.chatsPage) {
      console.log("onDownChats")
      this.getChats(this.chatsPage)
    }
  }

  getChats(chatsPage, value?) {
    let filterData = {};
    filterData[this.searchKey] = value ? value : this.searchControl.value

    console.log("filterData", filterData)
    
    if (this.chatsSub) {
      this.chatsSub.unsubscribe()
    }

    this.isLoad = true;
    this.attachSubscriptions(
      this.chatService.getChatsExpand(chatsPage, this.data.company.id, filterData, '20', this.filter.value.task_id, this.filter.value.task_operation_id).pipe(
        tap(el => {
          if (chatsPage == 1) {
            this.chatsPagination = {
              'pageCount': el.headers.get('x-pagination-page-count'),
              'perPage': el.headers.get('x-pagination-per-page'),
              'totalCount': el.headers.get('x-pagination-total-count'),
              'currentPage': el.headers.get('x-pagination-current-page'),
            }
          }
        }),
        map(el => el.body.filter(k => k.id != this.data.chat.id))
      ).subscribe(resp => {
        if (chatsPage == 1) {
          this.chats = resp;
        } else {
          this.chats.push(...resp);
        }
        this.chatsPage++;
        this.isLoad = false;
        console.log("openContext this.chats", this.chats)
      })
    )
  }

  close() {
    this.dialogRef.close({event: "close", data: false})
  }

  onSubmit() {
    this.isSubmit = true;

    console.log("this.selectedChat", this.selectedChat)

    if (!!this.selectedChat) {
      this.pasteMsg();
    } else {
      this.attachSubscriptions(
        this.chatService.createChat({
          task_operation_id: this.filter.value.task_operation_id,
          status_id: '1',
          name: this.newChatName.value,
          priority: 0
        }, this.data.company.id).subscribe(resp => {
          console.log(resp);
          this.selectedChat = resp;
          this.pasteMsg();
        }, error => {
          this.isSubmit = false;
          this.showError(error);
        })
      )
    }
  }

  showError(error) {
    this.layoutService.showSnackBar({name: error}, marker("You do not have permission to do this"), SnackBarItem)
  }

  checkIsManager(task, company, _user) { 
    return task?.managers.filter(x => x.user_id == _user.id).length > 0 || task?.group?.managers.filter(x => x.user_id == _user.id).length > 0 || company?.permissions.includes('admin') || company?.permissions.includes('owner') || company?.permissions.includes('manager'); 
  }

  neededData(task, company) {
    let arr = [
      this.chatService.getTasksChats(company.id, [task.id]).pipe(
        tap(res => {
          task['operations'].map(o_el => {
            o_el['chatsInfo'] = [];
            o_el['chatsInfo'].push(...res.filter(z => z.task_operation_id == o_el.id));
            o_el['unReadChats'] = res.filter(z => z.task_operation_id == o_el.id && z.is_read != '1').length;
            o_el['unClosedChats'] = res.filter(z => z.task_operation_id == o_el.id && z.status_id != '4').length;
          });
          task['chatsInfo'] = [];
          task['chatsInfo'].push(...res.filter(z => z.task_id == task.id));
          task['unReadChats'] = res.filter(z => z.is_read != '1').length;
          task['unClosedChats'] = res.filter(z => z.status_id != '4').length;
        })
      )
    ]
    if (task.company_id == company.id) {
      arr.push(
        this.taskService.getTaskClients(task.id, company.id).pipe(
          tap(res => {
            task.clients = res
          }),
          catchError(err => {
            return err
          })
        )
      )
    }
    return forkJoin(arr)
  }

  goToChat(chat) {
    console.log("goToChat", chat)
    this.attachSubscriptions(
      this.taskService.getOneTaskExpand(this.data.company.id, chat.task_id).pipe(
        map(x => x.body[0]),
        switchMap(x => this.neededData(x, this.data.company).pipe(map(() => casesModel([x], [], 'update')),map(x => x.arr[0]))),
      ).subscribe(resp => {
        chat.isLoad = false;
        
        const goToChat = this.dialog.open(OperationChatComponent, {
          backdropClass: ['backdrop_under_header', "without_pad"],
          panelClass: !this.data.is_mobile ? ['full_screen_dialog', 'global_chats_dialog', 'show_header'] : ['full_screen_dialog', 'global_chats_dialog'],
          position: !this.data.is_mobile ? { top: '58px', left: '0', right: '0', bottom: '0' } : {},
          autoFocus: this.data.is_mobile ? false : true,
          data: {
            company: this.data.company,
            task: resp,
            work: !!chat.task_operation_id && resp.operations.find(u => u.id == chat.task_operation_id) ? resp.operations.find(u => u.id == chat.task_operation_id) : undefined,
            dialogType: 'operation_chat',
            user: this.data.user,
            empl_status: this.data.company.permissions.includes('owner') || this.checkIsManager(resp, this.data.company, this.data.user),
            chat: chat,
            chats: this.chats,
            closeFull: true,
            operationsValues: this.data.operationsValues
          }
        });
    
        this.attachSubscriptions(
          goToChat.afterClosed().subscribe(result => {
            
          })
        )
        
        this.close();
      })
    )
  }

  pasteMsg() {
    if (!this.data.msgs) {
      this.layoutService.showSnackBar({name: ''}, marker("No copied msgs"), SnackBarItem)
      return
    }

    if (this.data.msgs.length == 1) {
      let pasteData:any = {
        discussion_id: this.selectedChat.id,
        id: this.data.msgs[0].id
      }
  
      this.attachSubscriptions(
        this.chatService.copyPost(pasteData, this.data.company.id).subscribe(resp => {
          console.log(resp);
          this.layoutService.showSnackBar({name: ''}, marker("Msg copied successfully!"), SnackBarItem)
          if (this.isOpenAfter) {
            this.goToChat(this.selectedChat)
          } else {
            this.close();
          }
          this.isSubmit = false;
        })
      )
    } else if (this.data.msgs.length > 1) {
      let sortedMsgs = this.data.msgs.sort((a, b) => a.id - b.id)
      let sbmtData = [];
      let partsSbmtData = [];

      this.ls.requests$.next({
        value: 0,
        target: "Copy msgs"
      })
      // sort((a, b) => a.id - b.id);
      sortedMsgs.forEach(msg => {
        sbmtData.push({
          "path": `/api/discussion-post/copy/`,
          "query": {"company_id": this.data.company.id},
          "method": "POST",
          "body": {
            [this.sm.localStorageGetItem('csrf_param')]: this.sm.localStorageGetItem('csrf_token'),
            discussion_id: this.selectedChat.id,
            id: msg.id
          }
        });
      });
  
      for (let i = 0; i < Math.ceil(sbmtData.length/10); i++) {
        partsSbmtData.push(sbmtData.slice(i*10, 10 + i*10))
      }
  
      let count = 0;
      concat(...partsSbmtData.map((param) => this.taskService.multiRequest(param))).pipe(
        tap(el => {
          this.ls.requests$.next({
            value: Math.round((100 / partsSbmtData.length) * (count+1)),
            target: "Copy msgs"
          })
          count++;
        }),
        last()
      ).subscribe(res => {
        console.log(res);
        if (this.isOpenAfter) {
          this.goToChat(this.selectedChat)
        } else {
          this.close();
        }
        this.isSubmit = false;
        this.layoutService.showSnackBar({name: ''}, marker("Msgs copied successfully!"), SnackBarItem)
      })
    }

  }

  ngOnDestroy(): void {
    if (this.chatsSub) {
      this.chatsSub.unsubscribe()
    }
    this.clearSubscriptions()
  }
}
